import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FieldError, svgSprite, Tooltip } from '../../../../../hybrid/wrappers';
import EditTitlteOfCheckbox from '../components/EditTitlteOfCheckbox/EditTitlteOfCheckbox';
import uikit from '../../../../../project/uikit/uikit.module.scss';
import css from './FormCheckboxSwitcher.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';

const Wrapper = (prop) => {
    if (prop.pending && prop.pending !== true) {
        return <Tooltip text={prop.pending}>{prop.children}</Tooltip>;
    }
    return <>{prop.children}</>;
};
const FormCheckboxSwitcher = ({
    pending,
    attribute,
    hint,
    disabled,
    title,
    handlers = {},
    compStyle,
    value,
    setFormData,
    errors,
    visible = true,
    edit = false
}) => {
    const { stylers, classes } = generateCompStylers(compStyle);
    const [val, setVal] = useState(value || false);

    const [showInput, setShowInput] = useState(false);
    const [newTitle, setNewTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const editTitle = () => {
        setShowInput((pre) => !pre);
    };
    const changeHandler = useCallback(() => {
        if (!disabled && !pending) {
            (async () => {
                setFormData(attribute, !val);
                setVal(!val);
                if (handlers?.onChange) {
                    setLoading(true);
                    await handlers.onChange(!val);
                    setLoading(false);
                }
            })();
        }
    }, [disabled, pending, setFormData, attribute, val, handlers]);

    useEffect(() => {
        setVal(value);
    }, [value]);
    if (!visible) return null;
    return (
        <div style={stylers.wrapper} className={classes.wrapper} onClick={handlers?.onClick}>
            {title?.text && (
                <div className={classnames(uikit.flexRow, uikit.alignItemsCenter)}>
                    <div style={stylers.text} className={classnames(css.formCheckboxTitleText, classes.text)}>
                        {title.text}
                    </div>
                    {hint && (
                        <Tooltip
                            text={hint}
                            compStyle={{
                                inner: classnames(title.hintClassName, css.formInfoTooltip)
                            }}
                        >
                            {svgSprite('info-circle', {
                                className: classnames(css.formInfoIcon, classes.formInfoIcon),
                                style: stylers.formInfoIcon
                            })}
                        </Tooltip>
                    )}
                </div>
            )}
            <Wrapper pending={pending}>
                <div style={stylers.label} className={classnames(css.formCheckboxBlock, classes.label)}>
                    <div
                        className={classnames(disabled ? css.formCheckboxBlockDisabled : null, classes.checkboxSwitcher)}
                        onClick={!loading ? changeHandler : () => {}}
                    >
                        <div
                            className={classnames(
                                css.formCheckboxSwitcher,
                                val && !pending && !loading ? css.formCheckboxSwitcherActive : ''
                            )}
                        >
                            <div
                                className={classnames(
                                    css.formCheckboxSwitcherCircle,
                                    {
                                        [css.formCheckboxSwitcherCircleActive]: val
                                    },
                                    {
                                        [css.formCheckboxSwitcherPending]: pending || loading
                                    }
                                )}
                            ></div>
                        </div>
                    </div>
                    {title?.body && !edit && (
                        <div onClick={!loading ? changeHandler : () => {}} style={stylers.title} className={classes.title}>
                            {title?.body}
                        </div>
                    )}
                    {hint && !title?.text && (
                        <Tooltip
                            text={hint}
                            compStyle={{
                                inner: classnames(css.formInfoTooltip, title.hintClassName)
                            }}
                        >
                            {svgSprite('info-circle', {
                                className: classnames(css.formInfoIcon, classes.formInfoIcon),
                                style: stylers.formInfoIcon
                            })}
                        </Tooltip>
                    )}
                    {edit && (
                        <div>
                            {!showInput ? (
                                <div className={classnames(uikit.flexRow, uikit.alignItemsCenter)}>
                                    <div
                                        style={{
                                            pointerEvents: 'none',
                                            ...stylers.title
                                        }}
                                        className={classes.title}
                                    >
                                        {title?.body}
                                    </div>
                                    <div className={css.formCheckboxSwitcherEditWrapper} onClick={editTitle}>
                                        {svgSprite('pen-field', {
                                            className: css.formCheckboxSwitcherEditIcon
                                        })}
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <EditTitlteOfCheckbox
                                        setShowInput={setShowInput}
                                        title={title.body}
                                        setNewTitle={setNewTitle}
                                        saveEditTitle={edit?.saveEditTitle}
                                        attribute={attribute}
                                        newTitle={newTitle}
                                        number={edit?.number}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Wrapper>
            {errors && errors.length ? errors.map((err, idx) => <FieldError key={`${attribute}${idx}`}>{err}</FieldError>) : null}
        </div>
    );
};
FormCheckboxSwitcher.propTypes = {
    pending: PropTypes.node,
    attribute: PropTypes.string,
    hint: PropTypes.node,
    disabled: PropTypes.bool,
    title: PropTypes.object,
    handlers: PropTypes.object,
    compStyle: PropTypes.object,
    value: PropTypes.bool,
    setFormData: PropTypes.func,
    errors: PropTypes.array,
    visible: PropTypes.bool,
    edit: PropTypes.bool
};
export default FormCheckboxSwitcher;
